import React, { useState } from 'react';
import { Link } from "react-scroll";
// SCSS
import './navbar.scss';
// Assets
import LogoImg from '../../assets/navbar/logo-small.png';
import MobileMenuIcon from '../../assets/navbar/mobile-menu.svg';

// Translation Data
const translations = {
  en: {
    about: "ABOUT",
    services: "SERVICES",
    clients: "CLIENTS",
    contact: "CONTACT",
  },
  ar: {
    about: "حول",
    services: "الخدمات",
    clients: "العملاء",
    contact: "اتصل",
  },
};

const DesktopNav = ({ userIsScrolled, mobileMenuOpen, language, toggleLanguage }) => {
  const isArabic = language === "ar";

  return (
    <nav className={`Navbar ${!userIsScrolled ? "extraLargeNavbar" : ""}`}>
      <div className="wrapper flex-s-between">
        <div>
          <Link to="hero" spy={true} smooth={true} offset={0} duration={500}>
            <img height={100} src={LogoImg} alt="logo" className="pointer" />
          </Link>
        </div>
        <div className="mobile__menu" onClick={mobileMenuOpen}>
          <img src={MobileMenuIcon} alt="menu" />
        </div>
        <div className="desktop__menu">
          <ul className={`flex-s-between ${isArabic ? "rtl" : ""}`}>
         
             <li>
              <Link
                activeClass="active-link"
                to="about"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                {isArabic ? "من نحن" : "ABOUT"}
              </Link>
            </li>
            <li>
              <Link
                activeClass="active-link"
                to="services"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                {isArabic ? "خدماتنا" : "SERVICES"}
              </Link>
            </li>
            <li>
              <Link
                activeClass="active-link"
                to="blog"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                {isArabic ? "عملائنا" : "CLIENTS"}
              </Link>
            </li>
            <li>
              <Link
                activeClass="active-link"
                to="contact"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                {isArabic ? "اتصل بنا" : "CONTACT"}
              </Link>
            </li>
          </ul>
          <button className="language-toggle" onClick={toggleLanguage}>
            {isArabic ? "English" : "العربية"}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default DesktopNav;

